import { Component, EventEmitter, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { HubtypeProviderAccount } from '../../../models/hubtype-provider-account'

@Component({
  selector: 'app-channels-telegram',
  templateUrl: './telegram.component.html',
  styleUrls: ['./telegram.component.scss'],
  standalone: false,
})
export class TelegramComponent {
  telegramChannel = {
    telegramBotToken: '',
    telegramBotName: '',
  }
  pattern = '^[0-9]{9,10}:[a-zA-Z0-9_-]{35,36}$'

  get titleText(): string {
    return this.translate.instant('shared.addChannels.telegram.title')
  }
  get step1TitleText(): string {
    return this.translate.instant('shared.addChannels.telegram.step1Title')
  }
  get step1IntroText(): string {
    return this.translate.instant('shared.addChannels.telegram.step1Intro')
  }
  get step1LinkText(): string {
    return this.translate.instant('shared.addChannels.telegram.step1Link')
  }
  get step1OutroText(): string {
    return this.translate.instant('shared.addChannels.telegram.step1Outro')
  }
  get botUsernameInfoText(): string {
    return this.translate.instant('shared.addChannels.telegram.botUsernameInfo')
  }
  get step2TitleText(): string {
    return this.translate.instant('shared.addChannels.telegram.step2Title')
  }
  get botUsernamePlaceholder(): string {
    return this.translate.instant(
      'shared.addChannels.telegram.botUsernamePlaceholder'
    )
  }
  get tokenPlaceholder(): string {
    return this.translate.instant(
      'shared.addChannels.telegram.tokenPlaceholder'
    )
  }
  get tokenHintText(): string {
    return this.translate.instant('shared.addChannels.telegram.tokenHint')
  }
  get connectBotText(): string {
    return this.translate.instant('shared.addChannels.telegram.connectBot')
  }

  @Output() newChannel = new EventEmitter<HubtypeProviderAccount>()
  constructor(private translate: TranslateService) {}

  addTelegram() {
    const provider = new HubtypeProviderAccount()
    provider.provider = HubtypeProviderAccount.TELEGRAM
    provider.credentials = this.telegramChannel.telegramBotToken
    provider.name = this.telegramChannel.telegramBotName
    this.newChannel.emit(provider)
  }
}
